export default "__VITE_ASSET__BQ4n$1dw__"